import React, { Component } from "react";
import { Table, Button, Modal, Row, Col, Tooltip, message, Icon, Select } from "antd";
import axios from "axios";
import "./Pages.css";
import EstoquePrintModal from "../relatorios/EstoquePrintModal";
import FiltrosForm from '../components/FiltrosForm';
import moment from "moment-timezone";
import numeral from "numeral";
import { getUsuario, getTemPermissao, getTipoUsuario, getEmpresa } from "../utils/LoginManager";
import Colors from "../utils/Colors";
import InputForm from "../components/InputForm";


const dateFormat = 'DD/MM/YYYY'
const { Column } = Table;
const ButtonGroup = Button.Group;
const { Option } = Select;


export default class extends Component {
  state = {
    listaRegistros: [],
    registro: '',
    eventStatus: '',
    carregando: false,

    qtdePedNSinc: 0,
    qtdePed: 0,
    qtdeOrc: 0,
    vlrTotalPed: 0,
    vlrTotalOrc: 0,

    selectedRowKeys: [],

    formFiltroVisivel: false,

    filtros: {
      tipoTela: 'ESTPROD',
      buscaOrdem: { campo: 'est_data', ordem: 'DESC' },
      buscaDataIni: moment(new Date(new Date().getFullYear(), new Date().getMonth(), 1)).format('DD/MM/YYYY'),
      buscaDataFim: moment(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).format('DD/MM/YYYY'),
      buscaMes: 0,
      buscaAno: 0,
      buscaPessoa: { key: '0', },
      buscaUsuario: { key: '0', },
      buscaMunicipio: { key: '0', },
      buscaAgruparCidades: 0,
      buscaGrupoProduto: { key: '0' },
      buscaProduto: { key: '0' },
      buscaTipo: { key: 'X' },
      buscaControle: '',
      buscaLote: '',
      buscaAtividade: { key: '0', },
      buscaTipoAtiv: { key: 'X' },
    }

  };

  componentDidMount() {
    const usuario = getUsuario();
    getEmpresa().then(codEmpresa => {
      getTipoUsuario().then(tipoUsuario => {
        this.state.filtros.buscaUsuario = {
          key: getTemPermissao('UsuarioSupervisor', 'cons') ? '0' : usuario.usu_cpf
        }
        this.setState({
          usuario,
          codEmpresa,
          tipoUsuario,
        }, this.getListaRegistros);
      })
    })
  }

  componentDidUpdate(antProps, antState) {

  }



  getListaRegistros = () => {
    this.setState({ carregando: true, selectedRowKeys: [], });
    const { buscaDataIni, buscaDataFim, buscaProduto, buscaGrupoProduto, buscaControle, buscaLote, buscaOrdem } = this.state.filtros;

    let data_ini = '';
    if ((buscaDataIni) && (buscaDataIni !== undefined)) {
      data_ini = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }
    let data_fim = '';
    if ((buscaDataFim) && (buscaDataFim !== undefined)) {
      data_fim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }

    axios
      .get('/producao/listaEstoque', {
        params: {
          campoOrdem: buscaOrdem.campo,
          tipoOrdem: buscaOrdem.ordem,
          produto: buscaProduto.key,
          grupo: buscaGrupoProduto.key,
          controle: buscaControle,
          lote: buscaLote,
          data_ini,
          data_fim,
          print: 0,
        }
      })
      .then(response => {
        // console.log('getListaRegistros', response.data)

        this.setState({
          listaRegistros: response.data,
          carregando: false,
        });
      })
      .catch(erro => {
        console.warn(erro);
        this.setState({
          carregando: false,
        });
      });
  };





  onSalvarClick = (reg) => {
    const { selectedRowKeys, listaRegistros } = this.state;

    if ((!selectedRowKeys) || (selectedRowKeys.length === 0)) {
      Modal.warning({ title: 'Aviso!', content: 'Selecione algum produto' });
      return;
    }

    let listaProdutos = [];
    for (var x in selectedRowKeys) {
      const item = selectedRowKeys[x].split('_');
      const registroIndex = listaRegistros.findIndex(registro => String(registro.op_idf) === String(item[0]) && String(registro.pi_item) === String(item[1]) && String(registro.pi_seq) === String(item[2]))

      if ((registroIndex >= 0) &&
        (listaRegistros[registroIndex].qtde_venda) &&
        (parseFloat(listaRegistros[registroIndex].qtde_venda) > 0) &&
        (parseFloat(listaRegistros[registroIndex].qtde_venda) <= (parseFloat(listaRegistros[registroIndex].ap_qtde_producao) - (listaRegistros[registroIndex].qtdeItemVenda ? parseFloat(listaRegistros[registroIndex].qtdeItemVenda) : 0)))) {

        listaProdutos.push({
          ven_idf: 0,
          vi_item: String(listaRegistros[registroIndex].pi_item),
          vi_seq: listaProdutos.length + 1,
          prod_idf: String(listaRegistros[registroIndex].pi_item),
          prod_codigo: listaRegistros[registroIndex].prod_codigo,
          prod_descricao: listaRegistros[registroIndex].prod_descricao,
          vi_qtde: parseFloat(listaRegistros[registroIndex].qtde_venda),
          vi_vlr_unit: parseFloat(listaRegistros[registroIndex].prod_preco_tab1),
          vi_perc_desc: 0,
          vi_vlr_desc: 0,
          vi_vlr_acres: 0,
          vi_vlr_total: parseFloat(listaRegistros[registroIndex].qtde_venda) * parseFloat(listaRegistros[registroIndex].prod_preco_tab1),
          vi_perc_comissao: 0,
          vi_tabela: 1,
          vi_vlr_tabela: parseFloat(listaRegistros[registroIndex].prod_preco_tab1),
          vi_idf_producao: listaRegistros[registroIndex].op_idf,
        });
      }
    };

    if (listaProdutos.length > 0) {
      this.setState({ formVisivel: false, selectedRowKeys: [] });
      this.props.onNovaVendaClick(listaProdutos);
    } else {
      Modal.warning({ title: 'Aviso!', content: 'Informe a quantidade correta para venda em cada item selecionado' });
      return;
    }
  }


  onCancelarClick = () => {
    this.setState({
      formVisivel: false
    })
  }


  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;

    this.setState({
      [id]: value
    });
  };

  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span style={{ fontSize: 11 }}>
          {dataMoment.format('DD/MM/YYYY')}
        </span>
      )
    } else {
      <span></span>
    }
  }

  renderPeriodo = (data) => {
    if (data) {
      const dataMoment = moment(data).format('MMMM');
      return (
        <span style={{ fontSize: 11 }}>
          {dataMoment.toUpperCase()}
        </span>
      )
    } else {
      <span></span>
    }
  }

  renderValor = (est_vlr_total, registro) => {
    return (
      <span style={{ fontSize: 11 }}> {numeral(parseFloat(est_vlr_total)).format('0,000.00')} </span>
    );
  };


  renderQtdeEstoque = (qtde, registro) => {
    return (
      <span style={{ fontSize: 11 }}> {registro.ap_qtde_producao - (registro.qtdeItemVenda ? registro.qtdeItemVenda : 0)} </span>
    );
  };

  renderPesoEstoque = (qtde, registro) => {
    return (
      <span style={{ fontSize: 11 }}> {registro.ap_peso_real - (registro.pesoItemVenda ? registro.pesoItemVenda : 0)} </span>
    );
  };



  renderQtdeVenda = (data, registro) => {
    let disab = false;
    for (var x in this.state.selectedRowKeys) {
      if (this.state.selectedRowKeys[x] === registro.op_idf + '_' + registro.pi_item + '_' + registro.pi_seq) {
        disab = true;
      }
    }
    return (
      <Col xs={24} style={{ marginTop: -5, marginBottom: -30 }}>
        <InputForm
          type="number"
          id="qtde_venda"
          ref="qtde_venda"
          value={registro.qtde_venda}
          onChange={(value) => {
            registro.qtde_venda = value.target.value;
            this.forceUpdate();
          }}
          disabled={!disab}
        />
      </Col>
    )
  }


  renderUsuario = (usu_nome) => {
    return (
      <span style={{ fontSize: 11 }}>{usu_nome.substring(0, 10)}</span>
    );
  };



  onAbrirFiltroClick = () => {
    this.setState({
      formFiltroVisivel: true,
      filtros: {
        tipoTela: this.state.filtros.tipoTela,
        buscaOrdem: this.state.filtros.buscaOrdem,
        buscaDataIni: this.state.filtros.buscaDataIni,
        buscaDataFim: this.state.filtros.buscaDataFim,
        buscaMes: this.state.filtros.buscaMes,
        buscaAno: this.state.filtros.buscaAno,
        buscaPessoa: this.state.filtros.buscaPessoa,
        buscaUsuario: this.state.filtros.buscaUsuario,
        buscaMunicipio: this.state.filtros.buscaMunicipio,
        buscaAgruparCidades: this.state.filtros.buscaAgruparCidades,
        buscaGrupoProduto: this.state.filtros.buscaGrupoProduto,
        buscaProduto: this.state.filtros.buscaProduto,
        buscaTipo: this.state.filtros.buscaTipo,
        buscaControle: this.state.filtros.buscaControle,
        buscaLote: this.state.filtros.buscaLote,
      }
    })
  };

  onFiltrarClick = (filtros) => {
    this.setState({
      formFiltroVisivel: false,
      filtros,
    },
      this.getListaRegistros(filtros)
    )
  };

  onCancelarFiltroClick = () => {
    this.setState({
      formFiltroVisivel: false,
    })
  };







  onOrdenarListaClick = (column) => {
    const { filtros } = this.state;
    const ordem = filtros.buscaOrdem.campo && filtros.buscaOrdem.campo === column.dataIndex ? (filtros.buscaOrdem.ordem && filtros.buscaOrdem.ordem === 'ASC' ? 'DESC' : 'ASC') : 'ASC';
    filtros['buscaOrdem'] = { campo: column.dataIndex, ordem };
    this.setState({
      filtros,
    }, this.getListaRegistros)
  };

  renderTitulo = (col) => {
    return (
      <Tooltip title="Clique para Ordenar"><div style={{ background: "#ececec", cursor: 'pointer', padding: 2, marginLeft: -5, marginRight: -5 }}>{col}</div></Tooltip>
    );
  };




  onSelectChange = selectedRowKeys => {
    // console.log('selectedRowKeys changed: ', selectedRowKeys);
    this.setState({ selectedRowKeys });
  };

  expandedRowRender = (reg) => {
    // console.log('expandedRowRender111', reg)

    return (
      <Row>
        {reg.map((item) => (
          <div>
            {
              item.api_resultado ? (
                <Col xs={24} sm={3} style={{
                  flex: 1,
                  // height: 100,
                  padding: 5,
                  marginTop: 5,
                  marginRight: 5,
                  justifyContent: 'center',
                  borderBottom: '2px solid',
                  borderLeft: '2px solid',
                  borderColor: Colors.textDisabledDark,
                  backgroundColor: "white",
                }}>
                  <div style={{ flex: 1, fontSize: 10, fontWeight: 'bold', color: Colors.primaryDark }}>
                    {item.ta_descricao}
                  </div>
                  <div style={{ fontSize: 10, fontWeight: 'bold', color: Colors.primary, justifyContent: 'center' }}>
                    {item.tai_descricao}
                  </div>
                  <div style={{ fontSize: 12, color: Colors.textSecondaryDark }}>
                    {item.api_resultado}
                  </div>
                  {item.api_obs ? (
                    <div style={{ fontSize: 10, color: Colors.textDisabledDark }}>
                      {item.api_obs}
                    </div>
                  ) : null}
                </Col>
              ) : null
            }
          </div>
        ))}
      </Row>
    )
  };


  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { listaRegistros, carregando, formVisivel, salvando, selectedRowKeys, registroSelecionado, filtros, formFiltroVisivel } = this.state;

    // console.log('EstoqueProducaoPage.this.state: ', this.state);
    // console.log('EstoqueProducaoPage.this.props: ', this.props);

    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
    };
    const hasSelected = selectedRowKeys.length > 0;


    return (
      <div className="contentRoutesContainer">
        <h2 className="tituloPage">Estoque da Produção</h2>
        {this.props.tipoTela === 'venda' ? (
          <h3 style={{ color: Colors.textDisabledDark }}>Selecione os produtos para gerar a venda</h3>
        ) : null}
        <hr />
        <br />

        <div className="pageFiltro" style={{ height: 30 }}>
          {/* <Row> */}
          <Col xs={24} style={{ marginTop: -5 }}>
            {this.props.tipoTela === 'venda' ? (
              <Button
                className="botoesModalFormEditar"
                onClick={this.onSalvarClick}
                style={{ marginRight: 15 }}
              >
                Gerar Venda
              </Button>
            ) : null}

            <Button
              onClick={this.onAbrirFiltroClick}
              className="pageFiltro-filtrar"
              style={{ marginRight: 15 }}
            >
              Filtrar
            </Button>

            <FiltrosForm
              visivel={formFiltroVisivel}
              onFiltrarClick={this.onFiltrarClick}
              onCancelarFiltroClick={this.onCancelarFiltroClick}
              filtros={filtros}
            />


            {/* <EstoquePrintModal
                filtros={filtros}
              // vlrTotalPed={this.state.vlrTotalPed}
              // qtdePed={this.state.qtdePed}
              // vlrTotalOrc={this.state.vlrTotalOrc}
              // qtdeOrc={this.state.qtdeOrc}
              // qtdePedNSinc={this.state.qtdePedNSinc}
              /> */}

            <span style={{ marginLeft: 20, marginTop: 8, fontSize: 15, fontWeight: 'bold' }}>
              {hasSelected ? `Selecionados ${selectedRowKeys.length} items` : ''}
            </span>
          </Col>

          {/* </Row> */}

        </div>


        <div style={{}}>
          <Table
            pagination={false}
            onChange={this.onTabelaChange}
            loading={{
              spinning: carregando,
              tip: 'Carregando. Aguarde...',
              size: "large"
            }}
            dataSource={listaRegistros}
            rowKey={(registro => registro.op_idf + '_' + registro.pi_item + '_' + registro.pi_seq)}
            expandedRowRender={record => this.expandedRowRender(record.listaAnalises)}
            rowSelection={this.props.tipoTela === 'venda' ? rowSelection : null}
          >
            <Column
              key="prod_codigo"
              dataIndex="prod_codigo"
              title={this.renderTitulo("Produto")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={'5%'}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="prod_descricao"
              dataIndex="prod_descricao"
              title={this.renderTitulo("Descrição Produto")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={'12%'}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="ap_data_fabricacao"
              dataIndex="ap_data_fabricacao"
              title={this.renderTitulo("Período")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderPeriodo}
              width={'8%'}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="ap_data_fabricacao"
              dataIndex="ap_data_fabricacao"
              title={this.renderTitulo("Fabricação")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderData}
              width={'8%'}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="ap_data_validade"
              dataIndex="ap_data_validade"
              title={this.renderTitulo("Validade")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderData}
              width={'8%'}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="ap_num_lote"
              dataIndex="ap_num_lote"
              title={this.renderTitulo("Lote")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={'5%'}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="ap_controle"
              dataIndex="ap_controle"
              title={this.renderTitulo("Controle")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={'5%'}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="cap_descricao"
              dataIndex="cap_descricao"
              title={this.renderTitulo("Categoria")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={'8%'}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="ap_laboratorio"
              dataIndex="ap_laboratorio"
              title={this.renderTitulo("Analista")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={'8%'}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="ap_protocolo"
              dataIndex="ap_protocolo"
              title={this.renderTitulo("Turno")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={'8%'}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="qtdeItemVenda"
              dataIndex="qtdeItemVenda"
              title={this.renderTitulo("Estoq Atual")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderQtdeEstoque}
              width={'8%'}
              align="right"
              className="listaCadastro"
            />
            <Column
              key="ap_peso_real"
              dataIndex="ap_peso_real"
              title={this.renderTitulo("Peso Atual")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderPesoEstoque}
              width={'8%'}
              align="right"
              className="listaCadastro"
            />
            {this.props.tipoTela === 'venda' ? (
              <Column
                key="qtde_venda"
                dataIndex="qtde_venda"
                title={this.renderTitulo("Qtde Vender")}
                render={this.renderQtdeVenda}
                width={'12%'}
                align="right"
                className="listaCadastro"
              />
            ) : null}
          </Table>
        </div>
      </div >
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/EstoqueProducaoPage.js